var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_41_18",
    "data-name": "Component 41 \\u2013 18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M5.528,4.167A1.361,1.361,0,0,0,4.167,5.528v8.944a1.361,1.361,0,0,0,1.361,1.361h8.944a1.361,1.361,0,0,0,1.361-1.361V11.361a.583.583,0,0,1,1.167,0v3.111A2.528,2.528,0,0,1,14.472,17H5.528A2.528,2.528,0,0,1,3,14.472V5.528A2.528,2.528,0,0,1,5.528,3H8.639a.583.583,0,0,1,0,1.167Zm5.25-.583A.583.583,0,0,1,11.361,3h5.056A.583.583,0,0,1,17,3.583V8.639a.583.583,0,0,1-1.167,0V4.991l-4.06,4.06a.583.583,0,0,1-.824-.824l4.06-4.06H11.361a.583.583,0,0,1-.583-.583Z",
    transform: "translate(-3 -3)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open_link.8530485e9146f63a26a3327f7968d55f.svg";
export { ForwardRef as ReactComponent };